
import { useState } from 'react';
import { useToast } from "@/hooks/use-toast";
import { defaultPolicy, PolicyType } from '../components/types/PolicyTypes';

export interface PolicyManagerResult {
  policy: PolicyType;
  setPolicy: React.Dispatch<React.SetStateAction<PolicyType>>;
  isEditing: boolean;
  toggleEditing: () => void;
  handleSavePolicy: () => void;
}

export const usePolicyManager = (initialPolicy: PolicyType = defaultPolicy): PolicyManagerResult => {
  const [policy, setPolicy] = useState<PolicyType>(initialPolicy);
  const [isEditing, setIsEditing] = useState(false);
  const { toast } = useToast();

  const handleSavePolicy = () => {
    // Here you would typically save the policy to a backend
    setIsEditing(false);
    toast({
      title: "Investment Policy Updated",
      description: "Your changes to the investment policy have been saved.",
    });
  };

  const toggleEditing = () => {
    setIsEditing(!isEditing);
  };

  return {
    policy,
    setPolicy,
    isEditing,
    toggleEditing,
    handleSavePolicy,
  };
};
